/**
 *  This function is used to extend the default i18njs library with the ability to extend any method from it.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const overrideMethod = (I18njs: any, method: string, callback: (...args: any[]) => any) => {
  const originalI18njs = { ...I18njs };

  I18njs[method] = (...args: any[]) => {
    const next = originalI18njs[method].bind(I18njs);
    const result = callback(...args, next, I18njs);
    return result;
  };
};

const extendInterpolateWithNesting = (
  message: string,
  options: Record<string, any>,
  next: (message: string, options: Record<string, any>) => any,
  I18njs: any,
) => {
  let msg = message;
  const nestingRegex = /\$\((\S+)\)/gm;
  const nestedKeys = msg.match(nestingRegex);

  if (nestedKeys) {
    nestedKeys.forEach((key: string) => {
      const nestedKey = key.replace('$(', '').replace(')', '');
      const nestedValue = I18njs.t(nestedKey, options);
      msg = msg.replace(key, nestedValue);
    });
  }

  return next(msg, options);
};

export const extendI18n = (I18njs: any) => {
  overrideMethod(I18njs, 'interpolate', extendInterpolateWithNesting);
};
